<script>
/*jshint esversion: 6 */
import { inject, computed, watch} from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/locale/de.js';
export default {
    name: 'DateTime',
    components: {
        'datePicker': DatePicker,
        'font-awesome-icon': FontAwesomeIcon
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const langString = 'de';
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
                'vTxext': props.schema.validatorText
            };
            if (validateChild) {
                validateChild(toParent);
            }
        }, {deep: true});

        function getDateFormat(value) {
            switch (value) {
                case 'date': return 'DD.MM.YYYY';
                case 'datetime': return 'DD.MM.YYYY HH:mm:ss';
                case 'year': return 'YYYY';
                case 'month': return 'MM';
                default: return 'DD.MM.YYYY HH:mm:ss';
            }
        }
        return {
            langString,
            getDateFormat
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .dateField(
            :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
        )
        .datePicker.fieldDatePicker
            .form-group.row.gy-2.gx-3-align-items-left
                    label(
                        :for="id" 
                        v-if="schema.label && schema.label.length > 0"
                    ) 
                        |{{ schema.label }}
                        span.redAst(v-if="schema.required === true") *
            div
                datePicker(
                    v-model:value="model[schema.model]" 
                    :type="schema.dateformat" 
                    :lang="langString" 
                    :format="getDateFormat(schema.dateformat)" 
                    clearable="false" 
                    prefix-class="xmx"
                    :range="schema.range"
                    :disabled="disabled"
                )
                    template(#footer="{ emit }")
                        button(class="xmx-btn xmx-btn-text" @click="emit(new Date())") Heute            
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
            .vueFormSmall.labelred(v-if="schema.errorShow === true") 
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp;{{ schema.errorText[0] }}
</template> 